export default "__VITE_PUBLIC_ASSET__03dd68b2__"